import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WebsitesListItem} from "./websites-list-item.model";

@Component({
    selector: 'db-websites-list',
    templateUrl: './websites-list.component.html',
    styleUrls: ['./websites-list.component.scss'],
    standalone: false
})
export class WebsitesListComponent {

  @Input() title: string;
  @Input() websites: WebsitesListItem[];
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

}
